import { createAction } from 'redux-actions';
import { SeatMapRestrictions } from '@websky/graphql';

export interface SetSelectedFiltersPayload {
	passengerId: number;
	filters: Set<SeatMapRestrictions>;
}

export interface ClearPassengerFiltersPayload {
	passengerId: number;
}

export const setSelectedFilters = createAction<SetSelectedFiltersPayload>('SET_SELECTED_FILTERS');

export const clearPassengerFilters = createAction<ClearPassengerFiltersPayload>('CLEAR_FILTERS');

export type ClearPassengerFiltersAction = ReturnType<typeof clearPassengerFilters>;

export type SetSelectedFiltersAction = ReturnType<typeof setSelectedFilters>;
